"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DataParser_1 = __importDefault(require("../DataParser"));
const helpers_1 = require("js-common/lib/helpers");
class Two3PortalParser extends DataParser_1.default {
    constructor() {
        super();
    }
    parse(data) {
        let parsedData = data.map((item) => {
            let runData;
            let protocolData;
            let optionalData;
            let standardData;
            let userData;
            runData = Object.assign({}, item.details);
            protocolData = item.protocol.details;
            optionalData = item.optionalData || {};
            standardData = item.standardData.details || null;
            userData = {
                username: item.user || null,
                organization: item.organization || null,
                team: item.teamName || null
            };
            return {
                run: runData,
                protocol: protocolData,
                standard: standardData,
                user: userData,
                optional: optionalData
            };
        });
        return parsedData;
    }
    format(data) {
        let colorOrder = {
            "green": 0,
            "amber": 1,
            "red": 2
        };
        let formattedData = data.map((item) => {
            let runType = "Qualitative Run";
            if (item.run.BMStandardCurveId) {
                if (item.run.isQuant) {
                    runType = "Quantitative Run";
                }
                else {
                    runType = "Standard Curve";
                }
            }
            let runData = {
                id: item.run.__id__,
                parentId: item.run.BMFolderId,
                name: item.run.runName,
                timestamp: (0, helpers_1.generateTimeString)(item.run.timeStamp * 1000),
                duration: item.run.duration,
                sampleType: item.run.type || null,
                location: item.run.location || null,
                locationTag: item.run.locationString || null,
                latitude: item.run.gpsCoordinates.Latitude || null,
                longitude: item.run.gpsCoordinates.Longitude || null,
                version: Object.assign({}, item.run.systemInfo),
                notes: item.run.notes,
                targets: this.organizeWellData(item.run).sort((a, b) => {
                    if (a.wellNumber === b.wellNumber) {
                        return (colorOrder[a.color] - colorOrder[b.color]);
                    }
                    else {
                        return (a.wellNumber - b.wellNumber);
                    }
                }),
                runType
            };
            let standardCurve = null;
            if (item.standard) {
                if (item.run.BMStandardCurveId || item.run.isQuant) {
                    standardCurve = {
                        red: {
                            slopes: item.standard.standardCurveValues.slopes.red,
                            rSquares: item.standard.standardCurveValues.rSquares.red,
                            yIntercepts: item.standard.standardCurveValues.yIntercepts.red,
                            efficiencies: item.standard.standardCurveValues.efficiencies.red
                        },
                        green: {
                            slopes: item.standard.standardCurveValues.slopes.green,
                            rSquares: item.standard.standardCurveValues.rSquares.green,
                            yIntercepts: item.standard.standardCurveValues.yIntercepts.green,
                            efficiencies: item.standard.standardCurveValues.efficiencies.green
                        }
                    };
                }
            }
            let protocolData = {
                id: item.protocol.__id__,
                name: item.protocol.protocolName,
                rtTemp: item.protocol.rtTemp,
                rtTime: item.protocol.rtTime,
                firstDenatureTemp: item.protocol.firstDenatureTemp,
                firstDenatureTime: item.protocol.firstDenatureTime,
                cycleNums: item.protocol.numberOfCycles,
                denatureTemp: item.protocol.cycleDenatureTemp,
                denatureTime: item.protocol.cycleDenatureTime,
                annealTemp: item.protocol.cycleAnnealingTemp,
                annealTime: item.protocol.cycleAnnealingTime,
                extensionTemp: item.protocol.cycleExtensionTemp,
                extensionTime: item.protocol.cycleExtensionTime
            };
            return {
                run: runData,
                protocol: protocolData,
                standardCurve,
                user: item.user,
                optional: item.optional
            };
        });
        return formattedData;
    }
    organizeWellData(run) {
        let { wellData } = run;
        wellData = wellData.map((well) => {
            return well.targets.map((target) => {
                return {
                    name: target.shortTargetName,
                    color: target.fluorophoreName.toLowerCase(),
                    wellNumber: well.wellNum,
                    sampleName: target.shortTargetName,
                    threshold: target.threshold,
                    cq: target.CQ,
                    baselineData: [...target.baselineData],
                    rawData: [...target.rawData],
                    sq: target.SQ,
                    fluorophore: target.fluorophoreName.toLowerCase(),
                };
            });
        });
        wellData = [].concat.apply([], wellData);
        return wellData;
    }
}
exports.default = Two3PortalParser;
